import { useState } from 'react';
import { IoTrashOutline } from 'react-icons/io5';

// import { useNavigate } from 'react-router-dom';
import Error from '../Error';
import Loader from '../Loader';
import Pagination from '../Pagination';
import FilePreviewModal from '../utils/FilePreviewModal';
import DrawerModel from '../utils/drawer';
import { tableBackgroundColor } from '../utils/tableBackgroundColor';
import { formatDisplayDate } from '../utils/timeFormatter';
import { CreateAdminEvent } from './CreateAdminEvent';

import { AdminEventError } from '@/exceptions/admin-event/adminEvent.enum';
import useDeleteAdminEvent from '@/hooks/adminEvent/useDeleteEvent';
import { useGetAllAdminEvents } from '@/hooks/adminEvent/useGetAllEvents';
import {
	DrawerAdminEvent,
	IAdminEvent,
} from '@/interfaces/entities/admin-event';
import { notificationService } from '@/services/notification.service';

const AdminEventTable = () => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const [isEvent, setIsEvent] = useState<IAdminEvent | null>();
	const [currentPage, setCurrentPage] = useState(1);
	const [modalVisible, setModalVisible] = useState(false);
	const [url, setUrl] = useState('');
	// const navigate = useNavigate()

	const { events, isLoading, isError, error, totalPages, isPending } =
		useGetAllAdminEvents(currentPage);
	const deletEvent = useDeleteAdminEvent();

	if (isLoading || isPending) {
		return <Loader />;
	}

	if (isError) {
		return (
			<Error message={error ? error.message : AdminEventError.EVENT_ERROR} />
		);
	}

	const openEditModal = (events: IAdminEvent) => {
		setIsEvent(events);
		setIsCreateModalOpen(true);
	};

	const openCreateModal = () => {
		setIsCreateModalOpen(true);
	};

	const handlePreview = (url: string | null) => {
		if (url) {
			setUrl(url);
			setModalVisible(true);
		}
	};

	const handleDelete = async (id: number) => {
		try {
			await deletEvent.mutate(id);
		} catch (error) {
			notificationService.error('event deleted failed');
		}
	};

	const handleToggle = () => {
		setIsCreateModalOpen(false);
		setIsEvent(null);
	};
	return (
		<>
			<div className="px-4 sm:px-6 lg:px-8 w-full mb-10">
				<div className="sm:flex sm:items-center">
					<div className="flex justify-between font-bold sm:flex-auto">
						<h1
							data-test="h1-categories"
							className="text-base font-semibold leading-6 text-gray-900"
						>
							Event
						</h1>
						<button
							className="text-indigo-600 hover:text-indigo-900"
							data-test="button-add-category"
							onClick={openCreateModal}
						>
							Add Event
						</button>
					</div>
				</div>
				{events && events.length > 0 ? (
					<div className="mt-8 w-full  flow-root">
					<div className=" w-full overflow-x-auto">
						<div className="inline-block  min-w-[1100px] w-full py-2 align-middle">
								<table className="min-w-full table-auto divide-y divide-gray-300 border-red-300  border-spacing-x-4">
									<thead>
										<tr className="gap-x-2">
											<th
												scope="col"
												className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900 "
												data-test="th-id"
											>
												ID
											</th>
											<th
												scope="col"
												className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-name"
											>
												Title
											</th>

											<th
												scope="col"
												className="w-3/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-description"
											>
												Description
											</th>
											<th
												scope="col"
												className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-location"
											>
												Location
											</th>

											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-date"
											>
												Date
											</th>
											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-date"
											>
												Time
											</th>
											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-image"
											>
												image
											</th>

											{/* <th
                                            scope="col"
                                            className="w-3/12 py-3.5 text-center text-sm font-semibold text-gray-900"
                                            data-test="th-comments"
                                        >
                                            Comments
                                        </th> */}
											<th
												scope="col"
												className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-actions"
											>
												Actions
											</th>
										</tr>
									</thead>
									<tbody className="divide-y divide-gray-200">
										{events
											.slice()
											.sort(
												(a, b) =>
													new Date(b.date || '').getTime() -
													new Date(a.date || '').getTime(),
											)
											.map((event: IAdminEvent, index) => {
												return (
													<tr
														key={event.id}
														className={`${tableBackgroundColor(
															index,
														)} hover:bg-gray-200 min-h-8 gap-x-2`}
													>
														<td
															data-test="td-id"
															className="text-center max-w-sm py-4  text-sm font-medium text-gray-900 "
														>
															{event.id}
														</td>
														<td
															data-test="td-name"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{event.title}
														</td>

														<td
															data-test="td-description"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{event.description.length > 100
																? `${event.description.slice(0, 100)}...`
																: event.description}
														</td>
														<td
															data-test="td-location"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{event.location}
														</td>
														<td
															data-test="td-date"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{formatDisplayDate(event.date)}
														</td>
														<td
															data-test="td-time"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{event.time}
														</td>
														<td
															data-test="td-image"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															<button
																data-test="image-button"
																className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
																onClick={() => handlePreview(event.img)}
															>
																View
															</button>
														</td>
														{/* <td
                                                    data-test="td-comments"
                                                    className="text-center max-w-md py-4 text-sm text-gray-500"
                                                >
                                                    <button
                                                            data-test="comments-button"
                                                            className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
                                                            onClick={() => navigate(`/comments/event/${event.id}`)}
                                                        >
                                                            View
                                                            <span className="sr-only">{event.id}</span>
                                                        </button>
                                                </td> */}
														<td
															data-test="edit-notification-button"
															className="text-center text-md font-semibold "
														>
															<div className="flex justify-center items-center gap-6">
																<button
																	data-test="edit-event-button"
																	className="text-indigo-600 hover:text-indigo-900"
																	onClick={() => openEditModal(event)}
																>
																	Edit
																	<span className="sr-only">{event.id}</span>
																</button>

																<IoTrashOutline
																	className="cursor-pointer"
																	onClick={() => handleDelete(event.id)}
																/>
															</div>
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							</div>
						</div>
						<Pagination
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							totalPages={totalPages as number}
						/>
					</div>
				) : (
					<div className="w-full">
						<h1
							data-test="h1-events"
							className="text-base font-semibold text-center mt-20 leading-6 text-gray-900"
						>
							No Events Available
						</h1>
					</div>
				)}
				<FilePreviewModal
					visible={modalVisible}
					url={url}
					onClose={() => setModalVisible(false)}
				/>
			</div>
			<DrawerModel
				isOpen={isCreateModalOpen}
				isTitle={isEvent ? DrawerAdminEvent.Edit : DrawerAdminEvent.Create}
				setToggle={handleToggle}
			>
				<CreateAdminEvent
					editEvent={isEvent ?? null}
					setToggle={handleToggle}
				/>
			</DrawerModel>
		</>
	);
};

export default AdminEventTable;
